import { useFetch, useQuery } from "hooks/useQuery";
import { Filters, OnboardingApplicationStatus } from "consts/onboarding";
import type { ApplicationsResponse } from "features/onboarding/types";
import { getApplications } from "features/onboarding/api";
import type { ApplicationSummaryProps } from "./types";

export const useApplicationSummary = ({ whereUserRole }: ApplicationSummaryProps) => {
    const fetchQuery = (searchQueryParams: string) => getApplications(whereUserRole(searchQueryParams));

    const awaitingReviewApplications = useQuery<ApplicationsResponse>({
        getRequestQueryParams: requestQueryMapper =>
            requestQueryMapper
                .containsIn(Filters.status, OnboardingApplicationStatus.AwaitingReview),
        fetchQuery
    });

    const requestedChangesApplications = useQuery<ApplicationsResponse>({
        getRequestQueryParams: requestQueryMapper =>
            requestQueryMapper
                .containsIn(Filters.status, OnboardingApplicationStatus.RequestedChanges),
        fetchQuery
    });

    const inProgressApplications = useQuery<ApplicationsResponse>({
        getRequestQueryParams: requestQueryMapper =>
            requestQueryMapper
                .containsIn(Filters.status, OnboardingApplicationStatus.InProgress),
        fetchQuery
    });

    const approvedApplications = useQuery<ApplicationsResponse>({
        getRequestQueryParams: requestQueryMapper =>
            requestQueryMapper
                .containsIn(Filters.status, OnboardingApplicationStatus.Approved),
        fetchQuery
    });

    return useFetch(
        awaitingReviewApplications,
        requestedChangesApplications,
        inProgressApplications,
        approvedApplications
    )
};

export default useApplicationSummary;
